import { CustomDiv } from "@/common/divs";
import { LightText, SemiBoldText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

const Terms: React.FC = () => {
  return (
    <>
      <CustomDiv
        paddingY="16px"
        paddingX="30px"
        className="terms-and-conditions-card"
        style={{ border: "0px" }}
      >
        <LightText>
          Las Condiciones de Uso de VEE SIGHTSEER AGENCY, S.L. (en adelante
          “VSA”) que como Usuario aceptas al acceder a la página
          https://vee.travel/, así como a la aplicación “Vee Sightseer” (en
          adelante, el Sitio), y que estarán siempre accesibles bajo
          **https://vee.travel/** para tu consulta, archivo o impresión, son las
          siguientes:
        </LightText>
        <SemiBoldText style={{ marginTop: "16px" }} fontSize="18px">
          1. OBJETO DEL SITIO
        </SemiBoldText>

        <LightText style={{ marginTop: "16px" }}>
          A través del Sitio, VSA promociona actividades, entre otras, de tipo
          deportivo, cultural, turístico, terapéuticas, estéticas, etc. para su
          contratación (las “Actividades”).
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Las Actividades incluidas en el catálogo del Sitio son realizadas por
          empresas profesionales con reconocida trayectoria y garantías de
          solvencia técnica y económica (en adelante los “Afiliados”), que
          previamente han suscrito un contrato de Afiliación con VSA para poder
          ofrecer sus servicios a través del Sitio (en adelante el “Servicio” o
          los “Servicios”).
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          En el momento en que finalizas el proceso de compra estableces una
          relación comercial con el Afiliado, que es el responsable de la
          actividad contratada. VSA actúa como un promotor de las ofertas de los
          Afiliados y en este sentido es un mero intermediario entre tú y el
          Afiliado.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          2. ACCESO AL SITIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Si deseas contratar alguna actividad, con carácter previo, deberás
          darte de alta como Usuario. En este caso, como Usuario que accedes a
          nuestro Sitio para utilizar nuestros servicios, declaras y garantizas:
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          En caso de que accedas como persona física:
        </LightText>
        <LightText style={{ marginLeft: "32px" }}>
          • Que eres mayor edad o, en su defecto, cuentas con el consentimiento
          de tus padres o tutores legales para acceder a y/o usar el Sitio;{" "}
          <br />
          • Que has leído, entendido y aceptas las presentes Condiciones de Uso;
          <br />• Que toda la información personal que nos proporcionas (datos
          personales, de contacto, identificativos, fotografías, datos de
          facturación y datos bancarios, en su caso) es veraz, exacta, vigente y
          auténtica, y que la mantendrás debidamente actualizada y que aceptas
          expresamente nuestra Política de Privacidad.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Una vez dado de alta como Usuario, el Sitio te asignará un nombre de
          usuario y una contraseña de uso personal e intransferible, bajo tu
          única y exclusiva responsabilidad. En caso de que tengas sospechas o
          la certeza que tu cuenta puede estar siendo utilizada por un tercero,
          te invitamos a que lo comuniques inmediatamente a
          <b> help@vee.travel</b> para proceder a dar de baja tu nombre de
          usuario. Mientras no nos comuniques nada, tú eres el único responsable
          del uso que pueda realizarse del Sitio bajo tu nombre de Usuario
          registrado.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          3. UTILIZACIÓN CORRECTA DEL SITIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Como Usuario te obligas a hacer un uso correcto, diligente y lícito
          del Sitio, lo que supone, entre otros:
        </LightText>
        <LightText>
          • Que utilizarás el Sitio para los fines para los que está pensado y
          te abstendrás de cualquier uso del Sitio y/o de sus contenidos que sea
          contrario a la ley, el orden público, la moral o las buenas costumbres
          generalmente aceptadas y/o estas condiciones de uso;
          <br />
          • Que respetarás los derechos de propiedad intelectual e industrial
          del Sitio y de sus contenidos, así como todos los que corresponden a
          VSA o a terceros;
          <br />• Que no reproducirás, copiarás, transformarás, modificarás,
          distribuirás, comunicarás públicamente o pondrás a disposición del
          público el Sitio ni ninguno de sus contenidos, ni sus
          transformaciones, por ningún medio o modalidad de explotación.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Por ello, como Usuario responderás de cualquier daño o perjuicio de
          cualquier naturaleza que VSA pueda sufrir, directa o indirectamente,
          como consecuencia de un uso incorrecto del Sitio, un incumplimiento de
          estas Condiciones de Uso o de la Ley por tu parte.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA se reserva el derecho a suspender tu cuenta de usuario en el caso
          que constate un incumplimiento por tu parte de las obligaciones
          anteriormente señaladas. En ese caso, VSA te comunicará por escrito la
          suspensión de tu cuenta y te otorgará un periodo de tiempo para que
          subsanes tu incumplimiento. Transcurrido dicho plazo sin una
          subsanación satisfactoria a criterio de VSA o sin una respuesta por tu
          parte, VSA podrá darte de baja como usuario del Sitio.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          4. CONDICIONES DE CONTRATACIÓN
        </SemiBoldText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.1 CONTRATACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Cada actividad dispone de su propia ficha informativa en la que se
          describe en qué consiste la actividad, los horarios disponibles, el
          precio (con detalle de los impuestos aplicables) y su política de
          cambios y cancelación. Una vez elegida la actividad y con anterioridad
          a la contratación de ésta, si no estás registrado, el Sitio te
          solicita que te registres como Usuario, y para ello debes rellenar un
          formulario con tus datos personales.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Una vez dado de alta como Usuario Registrado el Sitio te permite
          continuar con el proceso de compra. Es responsabilidad del Usuario
          revisar y confirmar las características de la actividad contratada y
          que se ajustan a sus requerimientos y/o necesidades. Estas podrán ser
          consultadas en la sección de “Detalles” de cada actividad, así como en
          la sección de “Condiciones” para estar enterados de las condiciones de
          cancelación y particularidad de cada actividad.{" "}
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.1.1 ESTRUCTURA DE PRECIOS
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Los precios mostrados en el Sitio están compuesto por el precio de
          venta al público fijado por el Afiliado/Proveedor, el cual tiene
          libertad absoluta en mostrar los precios de sus actividades a su
          consideración y un pago proporcional por parte de VSA sobre el uso de
          su plataforma, tecnología e infraestructura para la comercialización y
          distribución de las actividades del Afiliado/proveedor. Esto se puede
          observar en el desglose de precios indicado al momento de la compra en
          el Sitio.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.2 PAGO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El pago se realiza mediante tarjeta bancaria a través de una pasarela
          de pago segura responsabilidad de la entidad que la opera. Para
          proceder al pago de la actividad debes facilitar los datos necesarios
          para realizar la transacción. VSA no tiene acceso a estos datos.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.3 CONFIRMACIÓN DE LA CONTRATACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Una vez finalizado el proceso de compra y autorizada la operación
          bancaria recibes un correo electrónico de confirmación de la
          contratación de la actividad en la dirección de email proporcionada,
          en el que figura la identificación del Afiliado, el número de
          contratación asignado y el importe total que te ha sido cargado en tu
          cuenta bancaria.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.1 ACTIVIDADES DE CONFIRMACIÓN INMEDIATA
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA cuenta con un sistema de confirmación inmediata de reservas sobre
          ciertas actividades contratadas por el Usuario. Éstas se indicarán al
          momento de su contratación y podrá visualizarlas en su sección de “Mis
          Reservas” del Sitio.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.2 ACTIVIDADES DE CONFIRMACIÓN PENDIENTE POR PARTE DEL AFILIADO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA también comercializa actividades que estén en estatus de PENDIENTE
          (PENDING) cuando requieran confirmación de disponibilidad por parte
          del Afiliado. Esto se informará a través de correo electrónico y en la
          sección de “Mis Reservas” del Sitio, una vez ingresado a su cuenta
          individual. Estas actividades no se consideran confirmadas ni existe
          aun vínculo comercial hasta que el Afiliado realice la confirmación o
          la cancelación de la solicitud de reserva.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Afiliado dispone de un máximo de 24 horas para confirmar la
          reserva, en donde el equipo de VSA procederá a cancelar la solicitud
          del usuario en caso de que el Afiliado no confirme exitosamente la
          disponibilidad o cancelación de la solicitud de contratación de
          actividades.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA no cobrará al usuario por actividades no confirmadas.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.3 PORTAL DEL USUARIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA otorga acceso al Usuario a su perfil, menú de reservas y datos de
          cuenta y facturación a través de:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • App disponible en tiendas de App Store® y Google Play ®
          <br />• Portal web en el sitio{" "}
          <a href="www.vee.travel" target="_blank">
            www.vee.travel
          </a>
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario podrá gestionar su información, consultar sus reservas,
          cambiar sus métodos de pago y configurar sus preferencias a través de
          estas herramientas.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.4 GESTIÓN DE RESERVAS
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario podrá gestionar las actividades compradas de los Afiliados
          de VSA, consultando el estatus de las mismas, bonos o vouchers
          generados y la posibilidad de cancelar las compras, siempre sujetas a
          las condiciones de cancelación de VSA y de las indicadas por el
          Afiliado en cada actividad previo a la compra.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Asimismo, tendrá acceso al historial de consumo con VSA en la sección
          de “Mis Reservas”.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario podrá consultar la información del Afiliado que
          proporcionará el servicio contratado, que es el nombre de la empresa,
          teléfono/s y correo electrónico, que servirá para cualquier aclaración
          o dudas del servicio.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario podrá consultar las condiciones especiales de cada
          actividad contratada, indicadas por el Afiliado en la sección de
          “Detalles” de cada actividad, recomendaciones y restricciones.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.5 VOUCHERS, BONOS Y DATOS DE CONTACTO DEL AFILIADO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA emitirá un bono al Usuario con la siguiente información:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          - <b>QR Escaneable</b>: Esta herramienta no tiene ningún costo y sirve
          como control de ingresos a las actividades reservadas
          <br />- <b>Código de reserva</b> para validar en el sistema las
          reservas realizadas por el Usuario por parte del Afiliado.
          <br />- <b>Datos del Afiliado</b>: El Usuario contará con la
          información del Afiliado que brindará los servicios, teléfonos de
          contacto, correo electrónico e instrucciones adicionales que sean
          necesarias para la realización de la actividad.
          <br />- <b>Información relacionada a la actividad</b>: Información
          registrada por parte del Afiliado, con el objetivo de que el Usuario
          esté enterado de las particularidades de la actividad contratada. Esto
          incluye: instrucciones de punto de encuentro, condiciones especiales
          de cancelación y reembolso, material y/o vestimenta obligatoria,
          condiciones especiales de la actividad.
          <br />
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Los bonos emitidos por VSA al Usuario se realizarán solamente por los
          siguientes medios:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • Vía la app de VSA VIAJERO, en la sección de Mis Reservas
          <br />• Vía el portal web de VSA VIAJERO, en la sección de Mis
          Reservas
          <br />• Vía correo electrónico al Usuario
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA no emitirá otro tipo de confirmación al Usuario, por lo que el
          Afiliado se reserva el derecho de realizar la actividad si no tiene la
          capacidad de confirmar la reserva realizada a través de VSA.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.3.6 RESPONSABILIDADES DEL USUARIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Es responsabilidad del Usuario entender y atender las condiciones
          indicadas en cada actividad, así como las reglas del Sitio de VSA. VSA
          no se hará responsable por omisiones por parte del Usuario si las
          condiciones de la Actividad del Afiliado son claras.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario tendrá también la responsabilidad de cumplir con las
          sugerencias e instrucciones que el Afiliado de para la realización de
          las actividades. VSA no es responsable de situaciones que ocurran
          durante la actividad, al ser únicamente intermediario comercial entre
          el Usuario y el Afiliado.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.4 FACTURACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>VSA emitirá:</LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • una factura en su propio nombre, como titular del Sitio, en concepto
          de cobro de los fees: por uso del Sitio por parte del usuario y por la
          tramitación de la operación con el Afiliado. El Usuario será informado
          de este importe y de su desglose detallado, antes de que finalice su
          pedido.
          <br />• El Afiliado proporcionará la factura del servicio contratado a
          través de VSA, por lo que en caso de que el Usuario la requiera,
          tendrá que solicitarla directamente al proveedor de la actividad
          correspondiente.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Igualmente, VSA entregará un recibo (como resumen y no como
          comprobante fiscal) al momento de la compra por el total de lo pagado
          por el Usuario. Este podrá ser enviado por correo electrónico al
          Usuario, así como descargarlo desde el Sitio.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.5 MÉTODOS DE PAGO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El Sitio ofrece a sus usuarios la posibilidad de realizar el pago de
          todas las actividades por medio de tarjeta bancaria, de crédito o de
          débito. Los pagos se realizan a través de la plataforma tecnológica
          Stripe que ofrece al usuario la garantía que el importe abonado es
          transferido al Afiliado con posterioridad a la realización de la
          actividad contratada.
        </LightText>
        <CustomDiv
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            marginTop: "16px",
          }}
        >
          <table>
            <tbody>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                    background: NEUTRO_TITLES_COLOR,
                  }}
                >
                  <SemiBoldText style={{ color: "white" }}>
                    TIPO DE CLIENTE
                  </SemiBoldText>
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                    background: NEUTRO_TITLES_COLOR,
                  }}
                >
                  <SemiBoldText style={{ color: "white" }}>
                    MÉTODO DE PAGO
                  </SemiBoldText>
                </th>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  Tarjetas Cliente Europeo/Internacional
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    maxWidth: "350px",
                  }}
                >
                  AMEX, Mastercard, Visa, UnionPay, Discover, Diners Club
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  Pagos Digitales / Wallets
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  Apple Pay, Google Pay
                </td>
              </tr>
            </tbody>
          </table>
        </CustomDiv>
        <LightText style={{ marginTop: "16px" }}>
          VSA no es responsable de las restricciones que imponga Stripe a la
          hora del alta de algún método de pago.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.6 POLÍTICA DE CAMBIOS EN LA COMPRA
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          En caso de que desees modificar alguna de las condiciones de compra de
          tu actividad (fecha, horario, número de participantes) deberás
          cancelar la actividad contratada. Para ello, deberás acceder a tu
          perfil, concretamente al apartado “Mis Reservas”, seleccionar la
          reserva que desees cancelar y una vez allí, haciendo click en el botón
          de cancelación, podrás cancelarla.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA también dispone de medios de contacto para aclaraciones,
          controversias y cambios a través del correo <a>help@vee.travel</a>
          indicando lo siguiente:{" "}
        </LightText>
        <SemiBoldText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • Código de reserva, indicado en el título del correo, al inicio con
          la siguiente estructura: VEE-XXXXX
          <br />• Nombre del usuario
          <br />• Tema a tratar
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Asimismo, el Usuario podrá contactar con el equipo de VSA a través del
          Sitio en la sección de “Contacto”.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El equipo de VSA apoyará al Usuario siempre sujeto a los Términos y
          Condiciones presentes, tanto de VSA como los indicados por el Afiliado
          en cada actividad.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.6.1 REASIGNACIÓN DE ACTIVIDADES POR PARTE DEL AFILIADO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El Afiliado podrá solicitar la reasignación de fecha y horario de la
          actividad contratada por el Usuario, debido a las siguientes causas y
          ajenas a VSA:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          - Condiciones meteorológicas que impidan la realización de la
          actividad
          <br />- Operación del servicio: equipos no disponibles, averías, falta
          de personal, etc.
          <br />- Situación política inestable en el lugar
          <br />- Situaciones de seguridad comprometida
          <br />- Factores externos que afecten el servicio del Usuario
          <br />- Otros motivos por el que el Afiliado decida que no puede
          llevar a cabo su Actividad
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Afiliado tendrá la obligación de respetar los acuerdos de
          cancelación unilateral indicados en estos Términos y Condiciones.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El Usuario recibirá una notificación con el cambio solicitado por
          parte del Afiliado en el Sitio y vía correo electrónico, con la
          libertad de aceptar el cambio o solicitar el reembolso correspondiente
          desde el Sitio, entendiendo que no es el servicio originalmente
          solicitado y será sujeto a la compensación del mismo. El Afiliado
          asume el riesgo de realizar estas operaciones en beneficio del Usuario
          afectado.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          El equipo de VSA gestionará esto en caso de no existir respuesta por
          parte del Usuario. Si éste no indica una respuesta, el equipo de VSA
          informará al Usuario sobre la cancelación y el reembolso
          correspondiente.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "32px" }}
        >
          4.6.2 CAUSAS DE FUERZA MAYOR
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA Y el AFILIADO se apegan a la normativa del artículo 1105 del
          Código Civil, sobre los derechos del VIAJERO a solicitar reembolsos
          debido a situaciones no previstas que impidan la realización del viaje
          y quede demostrado conforme a lo establecido en la ley.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.7 POLÍTICA DE CANCELACIÓN Y DERECHO DE DESISTIMIENTO:
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          De conformidad con la legalidad vigente, cada ficha de actividad
          disponible en el Sitio incluye de manera visible y fácilmente
          localizable la política de cancelación y el procedimiento para ejercer
          el derecho de desistimiento que te asiste. Te recomendamos que revises
          cuál es la política de cada Afiliado aplicable con anterioridad a la
          contratación de la actividad.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.8 DEVOLUCIÓN DE PAGOS EN CASO DE CANCELACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          En caso de cancelación de la actividad o de ejercicio del derecho de
          desistimiento, cumpliendo las condiciones estipuladas por la política
          de cancelación que corresponda a la ACTIVIDAD contratada, VSA
          procederá a la devolución del importe de la actividad contratada (el
          fee por uso de la plataforma no será reembolsado) satisfecho por el
          Usuario, en la misma tarjeta de crédito/débito con la que el Usuario
          haya realizado el pago de la actividad.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.9 REGLAS DE USO DE DESCUENTOS Y PROMOCIONES
        </SemiBoldText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.9.1 Descuentos y promociones por parte del Afiliado
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El Afiliado podrá manejar el precio de sus actividades a su criterio,
          siendo el responsable del PVP (precio de venta al público) siempre
          respetando la comisión pactada con VSA, marcada en el presente
          contrato. Estas promociones son a consideración del Afiliado, las
          cuales modificarán temporalmente el PVP marcado al cliente y son
          independientes de la estrategia comercial que maneje VSA en ese
          momento.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA no es responsable de ninguna de las promociones publicadas o
          creadas por parte del Afiliado.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          4.9.1 Descuentos y promociones por parte de VSA
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA se tomará la libertad de aplicar descuentos y promociones sobre el
          PVP fijado por el Afiliado, sin afectar el servicio contratado del
          Afiliado. El costo de estos descuentos o promociones son
          responsabilidad exclusiva de VSA.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA limita a UN cupón de descuento por compra, por lo que el Usuario
          no podrá hacer un uso acumulativo de promociones en una sola compra, a
          menos que sea específicamente indicado por parte de VSA. VSA tiene la
          libertad de definir los cupones, su uso y el número de veces que se
          pueden utilizar por Usuario.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          5. CONTENIDO FACILITADO POR LOS USUARIOS
        </SemiBoldText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          5.1 FEEDBACK DEL USUARIO
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Una vez hayas realizado tu actividad recibirás una invitación a
          rellenar una encuesta para conocer tu opinión sobre el Sitio, la
          actividad y el Afiliado. En paralelo, puedes realizar tus aportaciones
          y dar tus opiniones o publicar imágenes en nuestras redes sociales así
          como en nuestro Sitio y App.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          En cualquier caso, VSA tendrá la facultad de decidir la publicación o
          no del feedback del usuario, reservándose el derecho a no publicar
          contenido que, en su opinión, pueda no ser de interés para el resto de
          Usuarios o bien sea ofensivo, contrario al honor, la intimidad
          personal y familiar y la imagen, a la dignidad de la persona,
          discriminatorio por razón de sexo, edad, tendencia sexual, ideología,
          etnia, nacionalidad y/o incumpla la legalidad vigente.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          5.2 NORMAS DE PARTICIPACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          La publicación de contenidos por parte del Usuario se hará siempre de
          forma respetuosa, ajustada a la realidad, sin infringir derechos de
          terceros, ni la Ley, la moral ni las presentes Condiciones de Uso. El
          Usuario incluirá siempre contenidos y comentarios de su autoría,
          originales y sobre los que ostente los derechos necesarios para su
          publicación.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          5.3 LICENCIA DE USO:
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Como Usuario del Sitio y en relación con todo el contenido que
          publiques en el Sitio, la App y/o las redes sociales de VSA:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          5.3.1 Garantizas que eres titular de todos los derechos de propiedad
          intelectual sobre el contenido que publicas, por ser de tu propia
          autoría y/o, en caso de incorporar contenidos de terceros, que tienes
          autorización de su titular para publicarlos;
          <br /> 5.3.2 Garantizas que tienes el consentimiento de todas las
          personas identificables en cualquier imagen que subas a nuestras redes
          para proceder a su publicación;
          <br /> 5.3.3 Garantizas que tus publicaciones no infringen ningún
          derecho de tercero, ni la Ley, la moral ni las presentes Condiciones
          de Uso;
          <br /> 5.3.4 Otorgas una licencia de uso a favor de VSA, de carácter
          universal, gratuita, no exclusiva, pero con facultad de cesión a
          terceros, para la reproducción, distribución, comunicación pública y
          adaptación del contenido que publiques para su uso en el Sitio y redes
          sociales con las que VSA actúa, en interacción con el resto de
          Usuarios y garantizando la operativa del Sitio y redes sociales en la
          forma en las que se ofrecen, incluyendo usos promocionales y
          publicitarios de VSA y del Sitio. El Usuario garantiza a VSA el
          ejercicio pacífico de los derechos que cede y que le mantendrá
          completamente indemne de cualquier reclamación de tercero que derive
          del incumplimiento, por parte del Usuario, de las declaraciones y
          garantías aquí otorgadas.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          5.4 VSA se reserva el derecho a suprimir, archivar y borrar cualquier
          contenido que infrinja la Ley, las normas de participación o las
          presentes Condiciones de Uso, así como en respuesta a requerimientos
          oficiales o de terceros y/o para dar cumplimiento a obligaciones
          legales.
          <br /> 5.5 Asimismo, el incumplimiento de las presentes Condiciones de
          Uso en la publicación de contenidos dará a VSA la facultad de
          bloquear, suprimir, retirar tanto contenidos como cuentas de Usuarios,
          a su sola discreción.
        </LightText>
        <SemiBoldText fontSize="18px" style={{ marginTop: "16px" }}>
          6. RESPONSABILIDAD DE VSA
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          La responsabilidad de VSA en cuanto a los servicios ofrecidos a través
          del Sitio, es la legalmente prevista en la normativa española que le
          es de aplicación y que se refleja en las presentes Condiciones de Uso.
          En todo caso, el importe máximo porel que responderá VSA frente al
          Usuario quedará limitado al importe efectivamente satisfecho por el
          Usuario con motivo de la contratación de la Actividad.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          6.1 ACTIVIDADES:
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Al utilizar el Sitio, reconoces y aceptas expresamente que VSA no se
          hace responsable de las Actividades ofrecidas por los Afiliados que
          son los únicos responsables de las mismas, y encargados de seleccionar
          qué Actividades publican para su oferta a través del Sitio, así como
          sus características y las condiciones de prestación de las mismas. En
          este sentido, toda la información que aparece en cada una de las
          fichas de las Actividades que se ofrecen en el Sitio ha sido
          facilitada por los Afiliados, así como sus políticas de cambios y/o
          cancelación. Por todo ello, al contratar una Actividad de algún
          Afiliado a través de nuestro Sitio, declaras conocer y aceptar que
          estás contratando directamente con el Afiliado que ofrece la
          Actividad, siendo VSA un mero intermediario entre Afiliado y Usuario.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          VSA no se hace en ningún caso responsable de:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • Los daños y perjuicios de toda naturaleza derivados de la falta de
          veracidad, exactitud, exhaustividad y/o actualidad de los datos
          proporcionados por el Usuario;
          <br />• Los daños y perjuicios de toda naturaleza derivados de la
          falta de veracidad, exactitud, exhaustividad y/o actualidad de los
          datos proporcionados por el Afiliado;
          <br />• Las lesiones, daños, robos o accidentes que puedas sufrir
          durante el transcurso de tu actividad, reconociendo el Usuario que el
          único responsable es el Afiliado que presta la Actividad;
          <br />• Las condiciones meteorológicas en las que el Afiliado lleve a
          cabo la Actividad contratada por el Usuario, correspondiendo
          únicamente al Afiliado la decisión sobre la idoneidad o no de realizar
          la actividad de acuerdo con las condiciones meteorológicas existentes
          en la fecha y horario contratados;
          <br />• La calidad y adecuación de la Actividad debiendo formularse
          las quejas y reclamaciones en cuanto a la Actividad al Afiliado, único
          responsable de la misma; en caso de insatisfacción, te invitamos a que
          nos lo comuniques para trasladar tu insatisfacción al Afiliado y
          procurar mediar entre ambas partes.La limitación de responsabilidad se
          aplicará en la medida máxima permitida por la ley en la jurisdicción
          aplicable.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          6.2 INTERRUPCIÓN DEL USO DEL SITIO:
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA se reserva el derecho a interrumpir temporalmente el acceso al
          Sitio en cualquier momento y sin previo aviso, cuando ello sea
          necesario por motivos técnicos, de seguridad, de control, o de
          mantenimiento.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          6.3 USO DEL SITIO:
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA no se hace en ningún caso responsable de:
        </LightText>
        <LightText style={{ marginTop: "16px", marginLeft: "32px" }}>
          • Las interrupciones, demoras o mal funcionamiento del Sitio, así como
          de los daños que puedan derivar de éstos, originados por causas que
          escapen a su control (incluidos fallos de suministro eléctrico, falta
          de acceso a redes de comunicación, ataques de hackers, virus u otros
          elementos lesivos), causas de fuerza mayor, o actuaciones culpables o
          dolosas del Usuario;
          <br />• El acceso no autorizado o uso de nuestros servidores seguros
          y/o cualquier información personal y/o información confidencial
          temporalmente almacenada en ellos;
          <br />• Cualquier pérdida o daño de cualquier tipo incurrido como
          resultado del uso de los Servicios;
          <br />• Los daños y perjuicios de toda naturaleza derivados de la
          falta de veracidad, exactitud, exhaustividad y/o actualidad de los
          datos proporcionados por el Usuario;
          <br />• Los daños y perjuicios de toda naturaleza derivados de la
          falta de veracidad, exactitud, exhaustividad y/o actualidad de los
          datos proporcionados por el Afiliado.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          La limitación de responsabilidad se aplicará en la medida máxima
          permitida por la ley en la jurisdicción aplicable.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          6.4 ÁMBITO TERRITORIAL DE ACTUACIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA opera y controla este Sitio desde sus instalaciones en España, por
          lo que no puede asegurar que los servicios del Sitio sean apropiados o
          estén disponibles para su uso en otros territorios y recuerda a sus
          Usuarios que, si acceden desde dichos otros territorios, son
          responsables de cumplir con cualquier otra legislación que les sea
          aplicable.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          7. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL DE VSA
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          El diseño de todo este Sitio y todos sus contenidos (a título
          enunciativo, no limitativo, texto, gráficos, logotipos, dibujos,
          fotografías, software, código fuente y otros) son titularidad
          exclusiva de VSA, a quien corresponden todos los derechos de propiedad
          intelectual e/o industrial que de los mismos derivan, en toda su
          extensión (es decir, por toda la duración legal de dichos derechos,
          para un ámbito territorial mundial y para todas y cualesquiera
          modalidades de explotación) o, alternativamente, le han sido
          debidamente licenciados para su explotación por sus legítimos
          titulares.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Queda, por lo tanto, estrictamente prohibida la explotación
          (reproducción, distribución, comunicación pública, puesta a
          disposición del público y/o transformación, incluida la traducción) de
          todos los contenidos del Sitio objeto de propiedad industrial e
          intelectual por medio alguno, sin mediar la previa autorización,
          otorgada por escrito, de VSA. Todo ello, bajo las sanciones civiles y
          penales previstas por la legislación vigente.
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          8. PLATAFORMA EUROPEA DE ODR
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          VSA informa a sus Usuarios de la existencia de la plataforma de
          resolución de litigios en línea facilitada por la Comisión Europea,
          que se encuentra disponible en el siguiente enlace:
          [http://ec.europa.eu/consumers/odr/](
          <a
            target="_blank"
            href="http://ec.europa.eu/consumers/odr/"
            rel="noreferrer"
          >
            http://ec.europa.eu/consumers/odr/
          </a>
          ).
        </LightText>
        <SemiBoldText
          fontSize="18px"
          style={{ marginTop: "16px", marginLeft: "16px" }}
        >
          9. LEGISLACIÓN Y JURISDICCIÓN
        </SemiBoldText>
        <LightText style={{ marginTop: "16px" }}>
          Este Sitio junto con todos sus textos legales se someten a la
          legislación española que les sea de aplicación. Excepto para aquellas
          cuestiones en las que, por imperativo legal, se fije un fuero
          determinado para la resolución de conflictos (caso, por ejemplo, de
          las cuestiones sometidas a la legislación de protección de
          consumidores y usuarios, art. 29 LSSI) para cualesquiera otras en las
          que se permita la selección de fuero, las partes se someten, con
          renuncia expresa de cualquier otro que les pudiera corresponder, a los
          Juzgados y Tribunales de la ciudad de Barcelona, España.
        </LightText>
        <LightText style={{ marginTop: "16px" }}>
          Historial de versiones:
        </LightText>
        <CustomDiv
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            marginTop: "16px",
          }}
        >
          <table>
            <tbody>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                    background: NEUTRO_TITLES_COLOR,
                  }}
                >
                  <SemiBoldText style={{ color: "white" }}>
                    Número de versión
                  </SemiBoldText>
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    textAlign: "center",
                    background: NEUTRO_TITLES_COLOR,
                  }}
                >
                  <SemiBoldText style={{ color: "white" }}>
                    Fecha de publicación y actualización
                  </SemiBoldText>
                </th>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  01
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    maxWidth: "350px",
                  }}
                >
                  18/07/2022
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  02
                </td>
                <td style={{ border: "1px solid black", padding: "5px" }}>
                  01/07/2024
                </td>
              </tr>
            </tbody>
          </table>
        </CustomDiv>
      </CustomDiv>
    </>
  );
};

export default Terms;
